<template>
  <div v-show="items.length > 0">
    <div class="row mb-3">
      <div class="col-12">
        <em class="fas fa-plus-circle text-orange mr-2" />
        <span>Pago Adicional</span>
      </div>
    </div>
    <div
      v-for="(item, index) in items"
      :key="`additional-payment-item-${index}`"
      class="row mb-3"
    >
      <div class="col-12">
        <div class="bg-secondary-9 rounded p-md-3 p-2">
          <div class="row">
            <div class="col-md-2 col-sm-12 pr-3 pr-md-0 pr-sm-3">
              <div class="row bg-white m-1 p-3 rounded">
                <span class="fa-stack fa-1x color-secondary-25 font-14 mr-3">
                  <em class="fas fa-circle fa-stack-2x" />
                  <em class="fas fa-dollar-sign fa-stack-1x fa-inverse" />
                </span>
                <div>
                  <span class="color-gray-6 font-14">Pago Adicional:</span>
                  <div :class="amountClass(item.additionalAmount)">
                    {{ getAdditionalAmount(item.additionalAmount) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-10 col-sm-12 pl-3 pl-md-0 pl-sm-3">
              <div class="row bg-white m-1 p-3 rounded pb-4">
                <div class="col d-flex pb-2">
                  <em class="fas fa-file-invoice color-orange mt-1" />
                  <div class="pl-3">
                    <span class="color-gray-6 font-14">Número de Jornal:</span>
                    <div class="color-black font-16">
                      {{ item.journalNumber || '-' }}
                    </div>
                  </div>
                </div>
                <div class="col d-flex">
                  <em class="fas fa-calendar-edit color-orange mt-1" />
                  <div class="pl-3">
                    <span class="color-gray-6 font-14">Fecha de Pago:</span>
                    <div class="color-black font-16">
                      {{ item.paymentDate | date }}
                    </div>
                  </div>
                </div>
                <div class="col d-flex">
                  <em class="fas fa-edit color-orange mt-1" />
                  <div class="pl-3">
                    <span class="color-gray-6 font-14">Comentario:</span>
                    <div class="color-black font-16">
                      {{ item.comment }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div
              class="col-md-2 col-sm-12 pl-4 pl-md-5 pl-sm-4 ml-4 ml-md-5 ml-sm-4"
            >
              <span class="color-gray-6 font-14 ml-n0 ml-md-n3 ml-sm-n0">
                Usuario:
              </span>
              <div class="color-black font-16 ml-n0 ml-md-n3 ml-sm-n0">
                {{ item.user }}
              </div>
            </div>
            <div class="col-md-8 col-sm-12 pl-5">
              <span class="color-gray-6 font-14">Fecha:</span>
              <div class="color-black font-16">
                {{ item.date | date }}
              </div>
            </div>
            <div v-if="showDelete(item)" class="delete-additional-payment">
              <action-button
                class="outline-danger btn-block-xs-only"
                i="fas fa-times-circle"
                text="Eliminar"
                @click="deleteAdditionalPayment(item)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import assistanceApprovalStatus from '@/utils/constants/assistanceApprovalStatus.js';

export default {
  name: 'PaymentAdditionalList',
  components: {
    ActionButton,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    amountClass() {
      return (total) =>
        Math.sign(total) > 0
          ? 'font-26 color-secondary-31'
          : 'font-26 color-secondary-28';
    },
    getAdditionalAmount() {
      return (amount) => {
        return amount > 0
          ? `${this.$options.filters.price(amount)}`
          : `-${this.$options.filters.price(Math.abs(amount))}`;
      };
    },
    showDelete() {
      return (item) =>
        !item.journalNumber &&
        item.assistanceSummaryStatusId != assistanceApprovalStatus.Pagado;
    },
  },
  methods: {
    deleteAdditionalPayment({ assistanceSummaryId }) {
      this.$emit('on-delete', assistanceSummaryId);
    },
  },
};
</script>

<style scoped lang="scss">
.delete-additional-payment {
  position: absolute;
  right: 33px;
}
@media only screen and (max-width: 768px) {
  .delete-additional-payment {
    position: relative;
    right: 0px;
    margin-left: 37px;
    margin-top: 10px;
  }
}
</style>
